import { Box, Typography, useTheme, Button, InputLabel, TextField, CircularProgress, Divider, Grid } from "@mui/material"
import SegurityImagen from "../../../../assets/SegurityImagen.png"
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useOt } from "../../../../shared/context/otContext"
import { useTaskContext } from "../../../../shared/context/taskContext"
import { useEffect, useState } from "react"
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

export default function SsomaReview() {
    const theme = useTheme()
    const [ssomaCode, setSsomaCode] = useState("")
    const { ot } = useOt()
    const { hash_code_task, getTaskByHash, taskByHash, getSsomaDocument, ssomaDocument,setSsomaDocument, loadingSsomaDocument, downloadSsomaDocument, loadingDownloadSsoma, saveSsomaCode } = useTaskContext()

    // Efecto de limpieza cuando el componente se desmonta
    useEffect(() => {
        return () => {
            setSsomaDocument(null)
        }
    }, [])

    // Efecto para manejar los cambios en el documento SSOMA
    useEffect(() => {
        // Limpiar el estado inmediatamente
        setSsomaDocument(null)
        
        // Solo buscar el documento si hay un código válido
        if (taskByHash?.ssoma_code_document && taskByHash.ssoma_code_document !== '') {
            getSsomaDocument(taskByHash.ssoma_code_document)
        }
    }, [taskByHash?.ssoma_code_document])



    const handleValidateAndSaveSsomaCode = async () => {
        const ssomaDocumentData = await getSsomaDocument(ssomaCode)
        if (ssomaDocumentData) {
            const successSave = await saveSsomaCode(ssomaDocumentData, ssomaCode, taskByHash.hash_code)
            if (successSave) {
                setSsomaCode("")
            }
        }
    }

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '18px', color: theme.palette.text.primary }}>SSOMA</Typography>
            {
                ot.status.name === "cancel" && taskByHash?.required_ssoma_document && !taskByHash?.ssoma_validate && (
                    <Typography variant="body1" sx={{ fontSize: '14px', color: theme.palette.text.secondary }}>
                        Esta tarea ha sido cancelada, y no se cargó el documento de SSOMA.
                    </Typography>
                )
            }
            { ot.status.name !== "cancel" && ot.status.name !== "completed" && <Typography variant="body1" sx={{ fontSize: '14px', color: theme.palette.text.secondary }}>
                {taskByHash?.required_ssoma_document && !taskByHash?.ssoma_validate ? "Para poder iniciar la tarea, debes validar el documento de SSOMA" : "Esta tarea requiere documentación de SSOMA para su ejecución."}
            </Typography>
}


            {ot.status.name === "in_process" && <Box sx={{ mt: 2 }}>
                <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                    {taskByHash.ssoma_validate ? 'Actualizar Documento' : 'Código de SSOMA'}
                </InputLabel>
                <TextField
                    placeholder="IPERC o ATS"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={ssomaCode}
                    onChange={(e) => setSsomaCode(e.target.value)}
                />

                <Button onClick={handleValidateAndSaveSsomaCode} disabled={ssomaCode.length < 3} 
                variant="contained" color="primary" startIcon={<CheckCircleIcon />} sx={{ mt: 1 }} size="small">{taskByHash.ssoma_validate ? 'Actualizar Documento' : 'Validar y guardar'}</Button>
            </Box>
            }

            {
                loadingSsomaDocument && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
                        <CircularProgress size={20} />
                        <Typography variant="body1" sx={{ fontSize: '14px', color: theme.palette.text.secondary, ml: 1 }}>  Cargando documento... </Typography>
                    </Box>
                )
            }

            {ssomaDocument && (
                <Box sx={{
                    mt: 3,
                    p: 2,
                    borderRadius: 2,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    border: `1px solid ${theme.palette.primary.light}`,
                    backgroundColor: theme.palette.background.paper
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography variant="h6" sx={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>
                            Documento SSOMA Validado
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={loadingDownloadSsoma ? <CircularProgress size={20} sx={{ color: 'white' }} /> : <PictureAsPdfIcon />}
                            onClick={() => downloadSsomaDocument(true)}
                            sx={{
                                fontSize: '12px',
                                fontWeight: 'bold',
                                boxShadow: '0 2px 5px rgba(0,0,0,0.2)',

                            }}
                        >
                            {loadingDownloadSsoma ? "Descargando..." : "Descargar PDF"}
                        </Button>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                                Formato
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                                {ssomaDocument.formato_name ? ssomaDocument.formato_name : ""}
                            </Typography>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                                Fecha de registro
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                                {ssomaDocument.fecha_registro ? ssomaDocument.fecha_registro : ""}
                            </Typography>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                                Supervisor
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                                {ssomaDocument.supervisor_fullname ? ssomaDocument.supervisor_fullname : ""}
                            </Typography>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                                Código de documento
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                                {taskByHash.ssoma_code_document || ssomaDocument.code}
                            </Typography>
                        </Grid>
                        {ssomaDocument.validate_by_ssoma && (
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: theme.palette.success.light,
                                    p: 1,
                                    borderRadius: 1,
                                    maxWidth: '100px'
                                }}>
                                    <CheckCircleIcon sx={{ color: "white", mr: 1, fontSize: 20 }} />
                                    <Typography variant="body2" sx={{ color: "white", fontWeight: 'bold' }}>
                                        Validado
                                    </Typography>
                                </Box>
                            </Grid>
                        )}
                        {!ssomaDocument.validate_by_ssoma && ssomaDocument.formato_name == "IPERC" && (
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: theme.palette.error.light,
                                    p: 1,
                                    borderRadius: 1,
                                    maxWidth: '130px'
                                }}>
                                    <CheckCircleIcon sx={{ color: "white", mr: 1, fontSize: 20 }} />
                                    <Typography variant="body2" sx={{ color: "white", fontWeight: 'bold' }}>
                                        No validado
                                    </Typography>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </Box>
            )}



            {ot.status.name === "in_process" && <Box sx={{
                backgroundColor: theme.palette.background.medium,
                padding: '20px',
                borderRadius: '10px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                position: 'relative',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                mt: 2
            }}>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" sx={{
                            color: theme.palette.primary.main,
                            fontSize: '18px',
                            fontWeight: 'bold',
                            marginBottom: '10px'
                        }}>
                            Tu seguridad es nuestra prioridad
                        </Typography>

                        <Typography variant="body1" sx={{
                            color: theme.palette.text.secondary,
                            fontSize: '14px',
                            marginBottom: '15px'
                        }}>
                            Sigue estos pasos para registrar un IPERC o ATS:
                        </Typography>

                        <Box component="ol" sx={{
                            paddingLeft: '20px',
                            margin: '0',
                            '& li': {
                                marginBottom: '8px',
                                fontSize: '14px',
                                color: theme.palette.text.primary
                            }
                        }}>
                            <li>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                    Ingresa a  <Box component="span" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, ml: '5px' }}> https://ssoma.cetemin.net.pe/</Box>
                                </Box>
                            </li>
                            <li>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                    Inicia sesión con tu correo institucional
                                </Box>
                            </li>
                            <li>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                    Selecciona si deseas crear IPERC o ATS
                                </Box>
                            </li>
                            <li>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                    Completa toda la información requerida
                                </Box>
                            </li>
                            <li>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                    Selecciona al supervisor responsable
                                </Box>
                            </li>
                            <li>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                    Espera la validación del supervisor
                                </Box>
                            </li>
                            <li>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                    Copia el código generado y pégalo en el cuadro de texto
                                </Box>
                            </li>
                        </Box>
                    </Box>


                </Box>

                <Button
                    variant="contained"
                    color="primary"
                    href="https://ssoma.cetemin.net.pe/"
                    target="_blank"
                    startIcon={<OpenInNewOutlinedIcon />}
                    sx={{
                        marginTop: '10px',
                        alignSelf: 'flex-start',
                        borderRadius: '20px',
                        padding: '5px 15px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                        '&:hover': {
                            transform: 'translateY(-2px)',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
                        }
                    }}
                >
                    Ir al portal SSOMA
                </Button>
            </Box>}
        </Box>
    )
}